var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 2C10.4142 2 10.75 2.33579 10.75 2.75V11.9393L13.4697 9.21967C13.7626 8.92678 14.2374 8.92678 14.5303 9.21967C14.8232 9.51256 14.8232 9.98744 14.5303 10.2803L10.5303 14.2803C10.3897 14.421 10.1989 14.5 9.99999 14.5C9.80108 14.5 9.61031 14.421 9.46966 14.2803L5.46967 10.2803C5.17678 9.98744 5.17678 9.51256 5.46967 9.21967C5.76256 8.92678 6.23744 8.92678 6.53033 9.21967L9.24999 11.9393V2.75C9.24999 2.33579 9.58578 2 9.99999 2ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H16.25C16.6642 16.5 17 16.8358 17 17.25C17 17.6642 16.6642 18 16.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "6c62c2561a4344d1e380a5aba2a4e5d9.svg";
export { ForwardRef as ReactComponent };